export const en = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Play",
  "menu.name": "Name",
  "menu.ballColor": "Ball color",
  "menu.nameColor": "Name color",
  "menu.moreInfo": "More Info",
  "menu.moreInfoTitle": "More Info",
  "menu.moreInfoSubtitle": "Legal pages, cookie details and contact information.",
  "menu.back": "Back",
  "menu.privacySettings": "Privacy Settings",
  "menu.cookiePolicy": "Cookie Policy",
  "menu.privacyPolicy": "Privacy Policy",
  "menu.termsOfService": "Terms of Service",
  "menu.emailButton": "Email Me",
  "menu.websiteButton": "Check Out My Website",
  "menu.contactEmailLabel": "Contact e-mail:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Check out my website:",
  "menu.nameRequired": "Enter a name first.",
  "moreInfo.privacySettings.intro1": "You can manage your privacy choices on this site through the consent message shown by our advertising provider when it is available.",
  "moreInfo.privacySettings.intro2": "You can also control cookies and local storage in your browser settings at any time.",
  "moreInfo.privacySettings.adsHeading": "Advertising controls",
  "moreInfo.privacySettings.adsParagraph": "Some ads may be provided by Google or other partners. Personalized advertising choices can also be managed directly in your Google ad settings.",
  "moreInfo.privacySettings.adsBullet1": "Open Google ad controls at myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Clear browser cookies or site data if you want to reset your consent choices.",
  "moreInfo.privacySettings.adsBullet3": "Use your browser privacy settings to block or limit cookies.",
  "moreInfo.privacySettings.localHeading": "Local settings",
  "moreInfo.privacySettings.localParagraph": "This game stores basic local preferences such as your player name, colors, sound preference and language so the site can remember them on your device.",
  "moreInfo.cookiePolicy.intro1": "This site uses cookies and similar storage technologies to run the game, remember your settings and support advertising.",
  "moreInfo.cookiePolicy.intro2": "Cookies may also be used for measurement, fraud prevention and ad personalization depending on your consent choices and the services enabled on the site.",
  "moreInfo.cookiePolicy.typesHeading": "Types of cookies and storage we may use",
  "moreInfo.cookiePolicy.typeBullet1": "Essential storage used to keep the site working.",
  "moreInfo.cookiePolicy.typeBullet2": "Preference storage used to remember your name, colors, language and sound setting.",
  "moreInfo.cookiePolicy.typeBullet3": "Advertising or measurement cookies used by ad partners such as Google when ads are enabled.",
  "moreInfo.cookiePolicy.manageHeading": "How to manage cookies",
  "moreInfo.cookiePolicy.manageParagraph": "You can manage cookies through the consent message on the site when available, or through your browser settings. Disabling some cookies may affect site features or ad delivery.",
  "moreInfo.privacyPolicy.intro1": "This site is a browser game operated by Michał Kierzkowski. We aim to collect as little personal information as possible.",
  "moreInfo.privacyPolicy.intro2": "No account is required to play. The game may store basic local preferences on your device and process gameplay data needed to run online matches.",
  "moreInfo.privacyPolicy.infoHeading": "Information we may process",
  "moreInfo.privacyPolicy.infoBullet1": "Your chosen player name and cosmetic settings.",
  "moreInfo.privacyPolicy.infoBullet2": "Basic gameplay session data required to run multiplayer features.",
  "moreInfo.privacyPolicy.infoBullet3": "Device, browser or advertising data collected by analytics or advertising partners if such services are enabled.",
  "moreInfo.privacyPolicy.useHeading": "How we use information",
  "moreInfo.privacyPolicy.useBullet1": "To run the game and online rooms.",
  "moreInfo.privacyPolicy.useBullet2": "To remember your settings on your device.",
  "moreInfo.privacyPolicy.useBullet3": "To improve performance, security and stability.",
  "moreInfo.privacyPolicy.useBullet4": "To display ads when advertising is enabled.",
  "moreInfo.privacyPolicy.contactHeading": "Contact",
  "moreInfo.privacyPolicy.contactParagraph1": "If you have privacy-related questions, contact: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Website: michalkierzkowski.com",
  "moreInfo.terms.intro1": "By using this site, you agree to use the game in a lawful and fair way.",
  "moreInfo.terms.intro2": "The game is provided on an as-is basis and may change, be interrupted or be removed at any time.",
  "moreInfo.terms.rulesHeading": "Rules",
  "moreInfo.terms.ruleBullet1": "Do not abuse bugs, cheats, automation or exploits.",
  "moreInfo.terms.ruleBullet2": "Do not attempt to harm the service or other players.",
  "moreInfo.terms.ruleBullet3": "Do not use offensive, unlawful or misleading names or content.",
  "moreInfo.terms.limitationHeading": "Limitation",
  "moreInfo.terms.limitationParagraph": "We are not responsible for losses, interruptions or damages resulting from use of the site to the maximum extent allowed by law.",
  "moreInfo.terms.changesHeading": "Changes",
  "moreInfo.terms.changesParagraph": "These terms may be updated in the future. Continued use of the site after updates means you accept the updated terms.",
  "status.offline": "Starting offline match...",
  "status.connecting": "Connecting to server...",
  "queue.title": "Waiting for a room",
  "queue.menu": "Return to main menu",
  "game.pressToMove": "Press anywhere to move",
  "game.touchToMove": "Touch anywhere to move",
  "game.leaderboard": "Leaderboard",
  "game.hp": "HP",
  "game.level": "Level",
  "game.xp": "XP",
  "game.respawning": "Respawning...",
  "gameEnd.title": "Game End",
  "gameEnd.winTitle": "You Win",
  "gameEnd.subtitle": "The match has ended. Respawn to start the next round or return to menu.",
  "pause.title": "Game menu",
  "pause.resume": "Continue",
  "pause.menu": "Return to main menu",
  "upgrade.title": "Choose an upgrade",
  "upgrade.generic.title": "Upgrade",
  "upgrade.generic.description": "Improve your build.",
  "upgrade.newWeaponPrefix": "New weapon:",
  "upgrade.stat.maxHp.title": "Max HP",
  "upgrade.stat.maxHp.description": "Increase maximum HP.",
  "upgrade.stat.speed.title": "Movement Speed",
  "upgrade.stat.speed.description": "Increase movement speed.",
  "upgrade.stat.generic.title": "Stat Upgrade",
  "upgrade.stat.generic.description": "Improve your stats.",
  "upgrade.weapon.projectileShot.title": "Projectile Shot",
  "upgrade.weapon.projectileShot.description": "Add projectile shots to your build.",
  "upgrade.weapon.orbitingBalls.title": "Orbiting Balls",
  "upgrade.weapon.orbitingBalls.description": "Add orbiting balls to your build.",
  "upgrade.weapon.damageZone.title": "Damage Zone",
  "upgrade.weapon.damageZone.description": "Add a damage zone around your character.",
  "upgrade.weapon.generic.title": "Weapon",
  "upgrade.weapon.generic.description": "Add this weapon to your build.",
  "upgrade.weaponUpgrade.frequency.title": "Frequency",
  "upgrade.weaponUpgrade.frequency.description": "Attack more often.",
  "upgrade.weaponUpgrade.range.title": "Range",
  "upgrade.weaponUpgrade.range.description": "Increase weapon range.",
  "upgrade.weaponUpgrade.projectileCount.title": "Projectile Count",
  "upgrade.weaponUpgrade.projectileCount.description": "Create more projectiles.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Projectile Speed",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Make projectile shots faster.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Orbital Speed",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Make orbiting balls rotate faster.",
  "upgrade.weaponUpgrade.damage.title": "Damage",
  "upgrade.weaponUpgrade.damage.description": "Deal more damage.",
  "upgrade.weaponUpgrade.generic.title": "Weapon Upgrade",
  "upgrade.weaponUpgrade.generic.description": "Improve this weapon.",
  "defeat.title": "Defeat",
  "defeat.subtitle": "Respawn or return to menu",
  "defeat.respawn": "Respawn",
  "defeat.menu": "Main menu",
  "error.generic": "Something went wrong.",
} as const;
